var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-data-editor',{attrs:{"id":_vm.id,"title":"Редактирование модели(ТМ)","resource":"trademark-models","elements":_vm.elements,"add-message":"Модель добавлена","edit-message":"Модель изменена","is-show-created-date":true},on:{"change":payload => (_vm.isChanged = payload)}})
}
var staticRenderFns = []

export { render, staticRenderFns }